import { WHY_POINTS } from '@/data/content';
import { Reveal, SectionHeading } from '@/components/Reveal';
import { scrollToId } from '@/lib/scroll';
import { trackEvent } from '@/lib/analytics';

export const WhyAJ = () => (
  <section id="why-aj" data-testid="why-aj-section" className="py-24 sm:py-32 bg-surface border-y border-white/5">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
        <SectionHeading chapter="06" label="Why Events by AJ" title={<>Why families & brands <span className="italic text-champagne">trust us</span></>} />
        <Reveal delay={0.15}>
          <button
            data-testid="why-aj-enquire-btn"
            onClick={() => { trackEvent('enquire_click', { location: 'why_aj' }); scrollToId('#enquiry'); }}
            className="btn-outline"
          >
            Tell Us About Your Event
          </button>
        </Reveal>
      </div>

      <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10">
        {WHY_POINTS.map((p, i) => (
          <Reveal key={p.title} delay={(i % 3) * 0.08} className="bg-ink p-8 sm:p-10 group hover:bg-surface transition-colors duration-500">
            <p className="font-serif text-5xl font-light text-champagne/30 group-hover:text-champagne transition-colors duration-500">
              {String(i + 1).padStart(2, '0')}
            </p>
            <h3 className="mt-6 font-serif text-2xl font-light text-cream">{p.title}</h3>
            <p className="mt-4 text-white/60 font-light leading-relaxed text-sm sm:text-base">{p.text}</p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
